import { useInfiniteQuery, useQuery } from 'react-query';
import { getArticles, getArticle } from 'apis/api';

export const useArticles = ({
  limit = 4,
  type = 'other',
  category = 'blog',
}) => {
  const query = useInfiniteQuery(
    [`'cms-${category}-list'`, limit, type],
    ({ pageParam = 1 }) =>
      getArticles({ page: pageParam, limit, type, category }),
    {
      getNextPageParam: (data) => {
        const { page, hasNextPage } = data?.pagination;

        return hasNextPage ? page + 1 : undefined;
      },
    }
  );

  const items = query.data?.pages?.flatMap((page) => page?.items ?? []) ?? [];

  const payload = {
    ...query,
    items,
  };

  return payload;
};

export const useArticle = ({ slug = '', category = 'blog' }) => {
  const query = useQuery([`cms-${category}-article`, slug], () =>
    getArticle({ slug, category })
  );

  return query;
};
